import socket, { invokeRPC } from './socket.js'

export function sendEmail(data) {
  return invokeRPC('emailReport', 'sendEmail', data)
}

export function getApplicableUsers(viewId) {
  return invokeRPC('emailReport', 'getApplicableUsers', { view_id: viewId })
}

export function getSnapshotWithFilters(viewId, filters, timeframe, exportType) {
  return invokeRPC('emailReport', 'getSnapshotWithFilters', {
    view_id: viewId,
    filters,
    timeframe,
    export_type: exportType
  })
}

export function getAllScheduledReports() {
  return invokeRPC('emailReport', 'getAllScheduledReports')
}

export function getScheduledReportsForProject(projectId) {
  return invokeRPC('emailReport', 'getScheduledReportsForProject', { project_id: projectId })
}

export function getScheduledReportDetails(reportId) {
  return invokeRPC('emailReport', 'getScheduledReportDetails', { report_id: reportId })
}

export function createScheduledReport(data) {
  return invokeRPC('emailReport', 'createScheduledReport', data)
}

export function updateScheduledReport(data) {
  return invokeRPC('emailReport', 'updateScheduledReport', data)
}

export function deleteScheduledReport(reportId) {
  return invokeRPC('emailReport', 'deleteScheduledReport', { report_id: reportId })
}

export function scheduleNextDueDate(reportId, dueDate) {
  return invokeRPC('emailReport', 'scheduleNextDueDate', {
    report_id: reportId,
    next_due_on: dueDate
  })
}

export function updateRecipients(reportId, recipients) {
  return invokeRPC('emailReport', 'updateRecipients', {
    report_id: reportId,
    recipients
  })
}

export function getScheduledDueStatus() {
  return invokeRPC('emailReport', 'getScheduledDueStatus')
}
